module.exports = __webpack_public_path__ + "fd200a83.png";